import { Slider } from "@/shared/ui/slider";
import { Input } from "@/shared/ui/input";
import { Button } from "@/shared/ui/button";
import { X } from "lucide-react";

interface Props {
  value: number | null | undefined;
  onChange: (next: number | null) => void;
}

function clamp(n: number): number {
  if (n < 0) return 0;
  if (n > 100) return 100;
  return n;
}

export function ConfidenceSlider({ value, onChange }: Props) {
  const current = typeof value === "number" ? value : 0;
  const isSet = typeof value === "number";

  const handleInput = (raw: string) => {
    if (raw.trim() === "") {
      onChange(null);
      return;
    }
    const parsed = Number(raw);
    if (Number.isFinite(parsed)) {
      onChange(clamp(Math.round(parsed)));
    }
  };

  return (
    <div className="flex items-center gap-3">
      <label className="text-xs text-muted-foreground w-20 shrink-0">Confidence</label>
      <Slider
        value={[current]}
        min={0}
        max={100}
        step={10}
        onValueChange={([next]) => onChange(next)}
        className="flex-1"
      />
      <Input
        type="number"
        min={0}
        max={100}
        step={10}
        value={isSet ? current : ""}
        onChange={(e) => handleInput(e.target.value)}
        className="h-7 w-20 text-xs tabular-nums px-2"
        aria-label="Confidence value"
      />
      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6"
        disabled={!isSet}
        onClick={() => onChange(null)}
        aria-label="Clear confidence"
      >
        <X className="h-3 w-3" />
      </Button>
    </div>
  );
}
